import useReaddyForm from '@/hooks/useReaddyForm';
import { categories } from '@/mocks/categories';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/dahgcqjp14a1h3mr6lv0';
const HONEYPOT = 'website_alt';

export default function SubscribeSection() {
  const { state, handleSubmit } = useReaddyForm(SUBMIT_ADDR, HONEYPOT);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:grid-cols-12">
        <div className="bg-primary-500 p-8 text-background-50 md:p-10 lg:col-span-5">
          <i className="ri-send-plane-line text-3xl text-accent-300"></i>
          <h2 className="mt-5 font-heading text-2xl font-bold md:text-3xl">订阅每周吃瓜简报</h2>
          <p className="mt-4 text-sm leading-relaxed text-background-100">
            每周挑出三到五件最值得关注的跨文化摩擦，附上背景梳理与双方观点，用一封邮件讲清楚，不制造焦虑，也不替你站队。
          </p>
          <ul className="mt-6 space-y-3 text-sm text-background-100">
            <li className="flex items-center gap-2">
              <i className="ri-check-line text-accent-300"></i>
              事件时间线 + 双方立场对照
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-check-line text-accent-300"></i>
              每周一期，随时可退订
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-check-line text-accent-300"></i>
              不发广告，不做内容打包转卖
            </li>
          </ul>
        </div>

        <div className="p-8 md:p-10 lg:col-span-7">
          <form
            id="meiri-subscribe-form"
            data-readdy-form
            action={SUBMIT_ADDR}
            method="post"
            onSubmit={handleSubmit}
            className="flex h-full flex-col justify-center"
          >
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
              <div className="sm:col-span-1">
                <label htmlFor="sub-email" className="mb-2 block text-sm font-medium text-foreground-800">
                  邮箱地址 <span className="text-primary-500">*</span>
                </label>
                <input
                  id="sub-email"
                  name="email"
                  type="email"
                  required
                  placeholder="you@example.com"
                  className="w-full rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50"
                />
              </div>
              <div className="sm:col-span-1">
                <label htmlFor="sub-interest" className="mb-2 block text-sm font-medium text-foreground-800">
                  最想关注的栏目
                </label>
                <select
                  id="sub-interest"
                  name="interest"
                  defaultValue=""
                  className="w-full cursor-pointer rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:bg-background-50"
                >
                  <option value="">都可以，挑最好看的发</option>
                  {categories.map((cat) => (
                    <option key={cat.slug} value={cat.name}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="sm:col-span-2">
                <label htmlFor="sub-note" className="mb-2 block text-sm font-medium text-foreground-800">
                  想补充的话（选填）
                </label>
                <textarea
                  id="sub-note"
                  name="note"
                  rows={3}
                  maxLength={500}
                  placeholder="比如：想多看点职场沟通相关的案例"
                  className="w-full resize-none rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50"
                ></textarea>
              </div>
            </div>

            <input
              className="form-honeypot"
              type="text"
              name={HONEYPOT}
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />

            <div className="mt-6 flex flex-col items-start gap-4 sm:flex-row sm:items-center">
              <button
                type="submit"
                disabled={state.status === 'submitting'}
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70 sm:w-auto"
              >
                {state.status === 'submitting' ? (
                  <>
                    <i className="ri-loader-4-line animate-spin"></i>
                    提交中
                  </>
                ) : (
                  <>
                    <i className="ri-mail-send-line"></i>
                    立即订阅
                  </>
                )}
              </button>
              <p className="text-xs leading-relaxed text-foreground-500">
                提交即表示你同意我们仅将邮箱用于发送简报。
              </p>
            </div>

            {state.status === 'success' && (
              <p className="mt-4 flex items-center gap-2 rounded-md border border-secondary-200 bg-secondary-50 px-4 py-3 text-sm text-secondary-800">
                <i className="ri-checkbox-circle-line"></i>
                {state.message}
              </p>
            )}
            {state.status === 'error' && (
              <p className="mt-4 flex items-center gap-2 rounded-md border border-primary-200 bg-primary-50 px-4 py-3 text-sm text-primary-700">
                <i className="ri-error-warning-line"></i>
                {state.message}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}